import '../styles/CommonButton.css';
import { useLoading } from './LoadingContext';
import { useState } from 'react';

const CommonButton = ({
  type = "button",
  onClick,
  children,
  className = "",
  disabled = false,
  isCancel = false,
}) => {
  return (
    <button
      onClick={onClick}
      type={type}
      disabled={disabled}
      className={
        disabled || isCancel
          ? `common-button-gray ${className}`
          : `common-button ${className}`
      }
    >
      {children}
    </button>
  );
};

export default CommonButton;
